export default "__VITE_ASSET__B475M0w$__"